"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageTitleRole = exports.breadcrumbRole = exports.menuIconColor = exports.menuIconSize = exports.classes = exports.HeaderConstants = void 0;
var HeaderConstants = {
  HEADER_PROPS: 'HEADER_PROPS'
};
exports.HeaderConstants = HeaderConstants;
var classes = {
  headerContainer: 'header-container',
  menuContainer: 'menu-container',
  breadcrumbWrapper: 'breadcrumb-wrapper',
  titleContainer: 'page-title-container',
  titleWithNoBreadcrumb: 'title-with-no-breadcrumb'
};
exports.classes = classes;
var menuIconSize = 24;
exports.menuIconSize = menuIconSize;
var menuIconColor = '#393939';
exports.menuIconColor = menuIconColor;
var breadcrumbRole = 'contentinfo';
exports.breadcrumbRole = breadcrumbRole;
var pageTitleRole = 'banner';
exports.pageTitleRole = pageTitleRole;